/** Routes for the manager side of Work Mode, kept in one place so deep links stay consistent. */

/** A station's setup page (`/mfg/workstations/:id`), optionally on one tab. */
export const stationHref = (
  stationId: string,
  tab?: 'overview' | 'photos' | 'tools' | 'parts' | 'instructions' | 'people',
) => `/mfg/workstations/${stationId}${tab && tab !== 'overview' ? `?tab=${tab}` : ''}`;

/** The instruction editor on the Workstations page, opened on one set. */
export const instructionEditorHref = (setId: string) =>
  `/mfg/workstations?tab=instructions&set=${setId}`;
